import { createFileRoute } from "@tanstack/react-router";
import { TranslationPricingCard } from "@/components/admin/TranslationPricingCard";

export const Route = createFileRoute("/admin/preklady-cenik")({
  component: PrekladyCenikPage,
  head: () => ({
    meta: [
      { title: "Ceník AI překladů — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});

function PrekladyCenikPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-8 space-y-4">
      <div>
        <h1 className="font-serif text-3xl">Ceník AI překladů menu</h1>
        <p className="text-sm text-muted-foreground">
          Toto nastavení je také dostupné v hlavní sekci <strong>Ceník</strong>.
        </p>
      </div>
      <TranslationPricingCard />
    </div>
  );
}
